
import {_axios as axios} from  "../../plugins/axios.js";
import kit from "../../plugins/kit.js"
let api = kit.api;

const defaultSetting = {
    invoice: true,
    invoiceHead: true,
    invoiceCompany: true,
    invoiceBarCode: true,
    invoiceInfo: true,
    invoiceCode: true,
    invoiceSender: true,
    invoiceReceiver: true,
    invoiceTel: true,
    invoiceAddr: true,
    pkgType: false,

    invoiceTable: true,
    invoiceTableName: true,
    invoiceTableQty: true,
    invoiceTablePrice: true,
    invoiceTableAmount: true,

    detail: true,
    detailCode: true,
    detailShelfCode: true,
    detailName: true,
    detailTitle: true,
    detailSpec: true,
    detailStoreType:false,
    detailPkg: true,
    detailDate: true,
    detailRemark1: true,
    detailRemark2: true,
    shopSellerMsg: true,
    shopName:false,
    ownerName:false,
    receiver:false,
    expGoodtype:false,
    orderPlatform:false,
    detailSku:false,
}

/**
 * 获取打印面单的配置
 * @returns 
 */
export const getTpConfigs = async () => {
    let ticketSetting = null;
    let result = await axios.get(api.user.tpConfig)
    if(result.status){
        if(result.data && result.data.length > 0){
            result.data.forEach(e=>{
                if(e.xvalue){
                    if(e.disabled == 1){
                        ticketSetting = JSON.parse(e.xvalue);
                    }
                }
            })
            if(!ticketSetting){
                ticketSetting = defaultSetting
            }
        }else{
            ticketSetting = defaultSetting
        }
    }
    return ticketSetting;
}

//获取打印提醒设置
export const getPrintWarn = async () => {
    let data = {
        printWarn: 0,
        printType: false
    }
    let result = await axios.get(api.user.pwConfig)
    if(result.status){
        if(result.data && result.data.length > 0){
            result.data.forEach(e=>{
                if(e.xvalue){
                    let printSet = JSON.parse(e.xvalue);
                    data.printWarn = printSet.printWarn?printSet.printWarn:0;
                    data.printType = printSet.printType?printSet.printType:false;
                }
            })
        }
    }
    return data;
}

